import { render, staticRenderFns } from "./ResetPsw.vue?vue&type=template&id=9b090912"
import script from "./ResetPsw.vue?vue&type=script&lang=js"
export * from "./ResetPsw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports